import "./App.css";
import React from "react";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import About from "./components/About";
import Services from "./components/Services";
import Process from "./components/Process";
import LocationMap from "./components/LocationMap";
import Contact from "./components/Contact";
import Partners from "./components/Partners";
import Footer from "./components/Footer";

function App() {
  return (
    <div className="App">
      <Navbar />
      <main>
        <Hero />
        <About />
        <Services />
        <Process />
        <LocationMap />
        <Contact />
        <Partners />
      </main>
      <Footer />
    </div>
  );
}

export default App;
